import { Req, getUrlParams, formatNum } from  './../util/util';
let orderNum = getUrlParams('orderNum');
if(!orderNum) alert("Test Nomor perintah hilang");

$(()=>{
    const methodsNames = {
        VABCA:'BCA',
        'BCA-BANK':'BCA',
        VAMANDIRI:'Mandiri',
        VAPERMATA:"Permata",
        VACIMB:"CIMB",
        VABNI:"BNI",
        'BNI-BANK':"BNI",
        VAMAYBANK:"Maybank",
        VABRI:"BRI",
        VADANAMON:"Danamon",
        OVO: "OVO",
        DANA: "DANA",
        ALFAMART: "ALFAMART",
        DT: "INDOMART",
        QRIS: "EWallet Scan",
        ATMBERSAMA:'ATM Bersama',
        SASP:'Sahabat Sampoerna'
    }

    getData();
    expandMenu();

    //获取订单数据
    function getData(){
        if(!orderNum) return ;
        Req({
            url: "/gateway/getPayMethod/v2",
            type: "POST",
            data: JSON.stringify({
                orderNum
            })
        }, res=>{
            let {
                walletMethod=[], storeMethod=[],
                bankMethod=[], vaMethod=[],
                customerName, payMoney,
                name, redirectUrl, onMethod, jumpUrl
            } = res.data || {};

            if(!jumpUrl){
                // console.log("11");
            }else {
                // console.log("22");
                window.location.href = jumpUrl;
                return;
            }

            $(".total-number .number").html(formatNum(payMoney));
            $(".card-footer-info .no").html(orderNum);
            $(".card-footer-info .barang").html(customerName);

            //va 列表渲染
            if(vaMethod && vaMethod.length){
                let bankListHtml = '<div class="halfpxline"></div>';
                vaMethod.forEach((item, index)=>{
                    bankListHtml += `
                    <a class="${item}" href="./html/${ item }.html?type=${item}&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/bank/${ item }.png" style="width: 80px;height: 24px;" alt="">
                                
                            </div>
                        </div>
                    </a>
                `;
                });
                bankListHtml += '<div class="halfpxline"></div>';
                $(".list-container .va .menu-items").html(bankListHtml);
            }else{
                $(".list-container .va").remove();
            }

            //bank 列表渲染
            if(bankMethod && bankMethod.length){
                let bankListHtml = '<div class="halfpxline"></div>';
                bankMethod.forEach((item, index)=>{
                    bankListHtml += `
                    <a class="${item}" href="./html/${ item }.html?type=${item}&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/bank/${ item }.png" style="width: 80px;height: 24px;" alt="">
                            </div>
                        </div>
                    </a>
                `;
                });
                bankListHtml += '<div class="halfpxline"></div>';
                $(".list-container .bank .menu-items").html(bankListHtml);
            }else{
                $(".list-container .bank").remove();
            }

            //wallet 列表渲染
            if(walletMethod && walletMethod.length){
                let walletListHtml = '<div class="halfpxline"></div>';
                walletMethod.forEach((item, index)=>{
                    walletListHtml += `
                    <a href="./html/${ item }.html?type=${ item }&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/wallet/${ item }.png" style="width: 80px;height: 24px;" alt="">
                            </div>
                        </div>
                    </a>
                `;
                });
                walletListHtml += '<div class="halfpxline"></div>';
                $(".list-container .wallet .menu-items").html(walletListHtml);
            }else{
                $(".list-container .wallet").remove();
            }

            //store 列表渲染
            if(storeMethod && storeMethod.length){
                let storeListHtml = '<div class="halfpxline"></div>';
                storeMethod.forEach((item, index)=>{
                    storeListHtml += `
                    <a href="./html/FT.html?type=FT&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/store/FT.png" style="width: 80px;height: 24px;" alt="">
                            </div>
                        </div>
                    </a>
                `;
                });
                storeListHtml += '<div class="halfpxline"></div>';
                $(".list-container .store .menu-items").html(storeListHtml);
            }else{
                $(".list-container .store").remove();
            }

            $('.back-to-last').click(e => {
                location.href = redirectUrl;
                return false;
            });
        }, error=>{
            console.log(error)
        })
    }
    //绑定展开菜单的事件
    function expandMenu(){
        $('.list-container .menu').click(function(){
            // $('.list-container .menu.active').removeClass('active')
            // $(this).addClass("active");
        });
    }
});
